import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FormManager } from "@120wateraudit/form-builder-components";

import Page from "src/components/Page";
import { SUBMISSION_PERIOD_TEMPLATES_PATHS } from "./paths";
import { useToken } from "../User";

const ManageSubmissionPeriodTemplatesPage: React.FC = () => {
  const navigate = useNavigate();
  const { token } = useToken();

  const handleCreateForm = useCallback((): void => {
    navigate(SUBMISSION_PERIOD_TEMPLATES_PATHS.new);
  }, [navigate]);

  const handleEditForm = useCallback(
    (formId: string): void => {
      navigate(SUBMISSION_PERIOD_TEMPLATES_PATHS.edit(formId));
    },
    [navigate]
  );

  return (
    <Page title="Submission Period Templates">
      <FormManager
        token={token ?? ""}
        onCreateForm={handleCreateForm}
        onEditForm={handleEditForm}
      />
    </Page>
  );
};

export default ManageSubmissionPeriodTemplatesPage;
